import useDeviceOrigin from '@weenat/client/dist/core/devices/useDeviceOrigin'
import { Device } from '@weenat/client/dist/resources/devices'
import { WeenatColor } from '@weenat/theme'
import { useIntl } from '@weenat/wintl'
import AdminBadge from 'app/src/kit/AdminBadge'
import isNil from 'lodash-es/isNil'

export const OriginBadge: FC<{ label: string; bgColor?: WeenatColor; lbColor?: WeenatColor }> = ({
  label,
  bgColor,
  lbColor
}) => {
  const badgeColor = bgColor ?? 'grayscale.500'
  const labelColor = lbColor ?? 'grayscale.black'

  return (
    <AdminBadge
      label={label}
      $backgroundColor={badgeColor}
      labelColor={labelColor}
      $px='300'
      $py='300'
      $borderRadius='sm'
    />
  )
}

const OwnerBadge = () => {
  const { t } = useIntl()

  const label = t('titles.my_farm', { capitalize: true })

  return (
    <AdminBadge
      label={label}
      $backgroundColor='plans.essential.500'
      labelColor={'grayscale.white'}
      $px='300'
      $py='300'
      $borderRadius='sm'
    />
  )
}

/**
 * This component may be displayed in both the devices list and the devices map,
 * so we have to account for both possibilities and fetch organization/network/networkOrganizations
 */
const DeviceOriginBadge: FC<{ device: Device }> = ({ device }) => {
  const { label, simplifiedOrigin } = useDeviceOrigin(device)

  return simplifiedOrigin === 'currentOrg' ? (
    <OwnerBadge />
  ) : (simplifiedOrigin === 'network' || simplifiedOrigin === 'adherentFarm') && !isNil(label) ? (
    <OriginBadge label={label} bgColor={'grayscale.black'} lbColor={'grayscale.white'} />
  ) : null
}

export default DeviceOriginBadge
